export const enum EAutomationActionType {
  CLICKUP_TASK = 'action.create.clickup.task',
  HUBSPOT_TASK = 'action.create.hubspot.task',
  MEETING_PURPOSE = 'action.set.meeting.purpose',
  MEETING_PRIVACY = 'action.set.meeting.privacy',
  CRM_CREATE_CONTACT = 'action.create.crm.contact',
  CRM_CREATE_LEAD_FROM_MEETING = 'action.create.crm.lead.from.meeting',
  CREATE_EMAIL_EVENTS = 'action.create.email.events',
  CREATE_CRM_TASK = 'action.create.crm.task',
  CREATE_CRM_EMAIL = 'action.create.crm.email',
  CREATE_CRM_CONTACT_FROM_EMAIL = 'action.create.crm.contact.from.email',
  CREATE_CRM_LEAD_FROM_EMAIL = 'action.create.crm.lead.from.email',
  MEETING_PURPOSE_USING_AI = 'action.set.meeting.purpose.ai',
  MEETING_OUTCOME = 'action.set.meeting.outcome',
  MEETING_OUTCOME_USING_AI = 'action.set.meeting.outcome.ai',
  MEETING_PURPOSE_AI_IN_AVOMA = 'action.set.meeting.purpose.ai.avoma',
  MEETING_PURPOSE_AI_IN_CRM = 'action.detect.and.log.meeting.purpose.ai',
  MEETING_RECORDING_PREFERENCE = 'action.set.meeting.recording.preference',
  MEETING_AUTOMAPPER_PREFERENCE = 'action.set.meeting.automapper.preference',
  SEND_TO_SLACK = 'action.send.meeting.summary.to.slack'
}

export const AUTOMATION_ACTION_TYPES = [
  EAutomationActionType.CLICKUP_TASK,
  EAutomationActionType.HUBSPOT_TASK,
  EAutomationActionType.MEETING_PURPOSE,
  EAutomationActionType.MEETING_PRIVACY,
  EAutomationActionType.CRM_CREATE_CONTACT,
  EAutomationActionType.CRM_CREATE_LEAD_FROM_MEETING,
  EAutomationActionType.CREATE_EMAIL_EVENTS,
  EAutomationActionType.CREATE_CRM_TASK,
  EAutomationActionType.CREATE_CRM_EMAIL,
  EAutomationActionType.CREATE_CRM_CONTACT_FROM_EMAIL,
  EAutomationActionType.CREATE_CRM_LEAD_FROM_EMAIL,
  EAutomationActionType.MEETING_PURPOSE_USING_AI,
  EAutomationActionType.MEETING_OUTCOME,
  EAutomationActionType.MEETING_OUTCOME_USING_AI,
  EAutomationActionType.MEETING_PURPOSE_AI_IN_AVOMA,
  EAutomationActionType.MEETING_PURPOSE_AI_IN_CRM,
  EAutomationActionType.MEETING_RECORDING_PREFERENCE,
  EAutomationActionType.MEETING_AUTOMAPPER_PREFERENCE,
  EAutomationActionType.SEND_TO_SLACK
];

export const enum EAutomationActionRules {
  TASK_TITLE = 'task_title',
  TASK_DESCRIPTION = 'task_description',
  TASK_WORKSPACE = 'task_workspace',
  TASK_LIST = 'task_spaces_and_list',
  TASK_TEMPLATE = 'task_template',
  TASK_DUE_DATE = 'task_due_date',
  TASK_ASSIGNEE = 'task_assignee',
  TASK_TYPE = 'hs_task_type',
  TASK_PRIORITY = 'hs_task_priority',
  MEETING_PURPOSE = 'meeting_purpose',
  MEETING_OUTCOME = 'meeting_outcome',
  MEETING_PURPOSE_USING_AI = 'meeting_purpose_ai',
  MEETING_OUTCOME_USING_AI = 'meeting_outcome_ai',
  ORGANIZER_TEAM = 'organizer_team',
  MEMBER_TEAM = 'member_team',
  MEETING_PRIVACY = 'meeting_privacy',
  MEETING_RECORDING_PREFERENCE = 'meeting_recording_preference',
  MEETING_AUTOMAPPER_PREFERENCE = 'meeting_automapper_preference',
  // email sync
  EMAIL_EVENT_SETTING = 'email_event_setting',
  CRM_TASK_SETTING = 'crm_task_setting',
  CRM_EMAIL_SETTING = 'crm_email_setting',
  CRM_CONTACT_FROM_EMAIL_SETTING = 'crm_contact_from_email_setting',
  CRM_LEAD_FROM_EMAIL_SETTING = 'crm_lead_from_email_setting',
  CRM_OWNER_ID = 'crm_owner_id',
  CRM_CONTACT_EMAIL_PUBLIC_PARTICIPANT = 'crm_contact_email_public_participant',
  CRM_CREATE_LEAD_SETTING = 'crm_lead_from_meeting_setting',
  // slack notification
  SEND_TO_SLACK = EAutomationActionType.SEND_TO_SLACK,
  SLACK_MESSAGE_TITLE = 'slack_message_title',
  SLACK_MESSAGE_CONTENT = 'slack_message_body',
  SLACK_ENTITIES_TO_NOTIFY = 'slack_entities_to_notify'
}

export const enum EAutomationActionAssigneeOptions {
  MEETING_HOST = 'meeting_host',
  RESP_USER_FOR_NOTES_EXT = 'resp_user_for_notes_ext',
  CLICKUP_MEMBER = 'clickup_member',
  HUBSPOT_MEMBER = 'hubspot_member'
}

export const enum EAutomationRuleUid {
  TEAM_SELECTION = 'team_selection',
  MEMBER_SELECTION = 'member_selection',
  MEETING_SUBJECT = 'meeting_subject',
  DEAL_VALUE = 'deal_value',
  MEETING_PURPOSE = 'meeting_purpose',
  MEETING_OUTCOME = 'meeting_outcome',
  DEAL_STAGE_NOW = 'deal_stage_now',
  DEAL_STAGE_DURING = 'deal_stage_during',
  PARTICIPANT_PUBLIC_DOMAIN = 'participant_public_domain',
  EMAIL_PARTICIPANT_PUBLIC_DOMAIN = 'email_participant_public_domain',
  EXT_PARTICIPANT_DOMAIN = 'ext_participant_domain',
  MEETING_PRIVACY = 'meeting_privacy',
  EMAIL_ADDRESS = 'email_address',
  EMAIL_SUBJECT = 'email_subject',
  EMAIL_EXTERNAL_PARTICIPANT_DOMAIN = 'email_external_participant_domain',
  MEETING_PARTICIPANT = 'meeting_participant'
}

// List of automation rule types that can be used for contact creation conditions
export const CONTACT_CREATION_RULES = [
  EAutomationRuleUid.TEAM_SELECTION,
  EAutomationRuleUid.MEMBER_SELECTION,
  EAutomationRuleUid.MEETING_SUBJECT,
  EAutomationRuleUid.DEAL_VALUE,
  EAutomationRuleUid.MEETING_PURPOSE,
  EAutomationRuleUid.MEETING_OUTCOME,
  EAutomationRuleUid.DEAL_STAGE_NOW,
  EAutomationRuleUid.DEAL_STAGE_DURING,
  EAutomationRuleUid.MEETING_PRIVACY,
  EAutomationRuleUid.EXT_PARTICIPANT_DOMAIN,
  EAutomationRuleUid.MEETING_PARTICIPANT
];
